var $ = require('jquery');

var FormView = require('app/common/views/form-view');
var Template = require('app/utils/template');
var ClientFeedbackTpl = require('./templates/client-feedback.html');

const FEEDBACK_INTERESTED = 10;
const FEEDBACK_DISMISSED = 20;
const FEEDBACK_NOT_SURE = 30;

var ClientFeedbackView = FormView.extend({
    className: 'client-feedback',
    template: Template(ClientFeedbackTpl),

    ui: {
        feedbackChoices: '[data-ui="feedbackChoice"]',
        formInputs: '[data-ui="formInputs"]',
        feedbackSubmitBtn: '[data-ui="feedbackSubmitBtn"]',
    },

    events: {
        'click @ui.feedbackChoices': 'clickChoice',
    },

    choiceToClass: {
        [FEEDBACK_INTERESTED]: '.like',
        [FEEDBACK_DISMISSED]: '.dislike',
        [FEEDBACK_NOT_SURE]: '.unsure',
    },

    fields: {
        feedback: {
            encoder: 'Integer',
            rules: {
                required: 'You must select one of the options above',
            },
        },
        notes: 'Text',
    },

    onRender: function() {
        this.listenToOnce(this, 'submit:success', this.compactPanel);
    },

    clickChoice: function(event) {
        const choice = $(event.target).data().value;
        this.selectChoice(choice);
    },

    selectChoice: function(choice) {
        const className = this.choiceToClass[choice];
        this.ui.feedbackChoices.removeClass('selected');
        $(className).addClass('selected');
        $('input[name="feedback"]').val(choice);
    },

    onShow: function() {
        const choice = this.model.get('feedback');
        if (choice) {
            this.selectChoice(choice);
        }
    },

    compactPanel: function() {
        this.ui.feedbackSubmitBtn
            .addClass('btn-success')
            .attr('disabled', true)
            .text('Feedback submitted!');
        this.ui.formInputs.stop(true, false).animate({ height: 'toggle', opacity: 'toggle' }, 600);
    },
});

module.exports = ClientFeedbackView;
